<template>
  <div>
    <div class='base_qrcode'>
      <div class='qrcode_group qrcode'>
        <vue-qr :logoSrc='qrcodeIcon' :text='qrcodeUrl' :size="190" :margin="10" :logoScale="0.2" :dotScale="0.8"></vue-qr>
      </div>
      <div class='qrcode_group demo_qrcode'>
        <img :src='tipsLogo'>
      </div>
    </div>
    <div class='base_tips'>
      <p class='tips_title'>
        <span>请打开手机端</span>
        <span id='light_tips_title'>应用首页>网页PDF转换>扫一扫</span>
        <span>扫码登录</span>
      </p>
      <p class='tips_body'>
        <span>如无法正常扫码登录，请更新应用App版本</span>
      </p>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'

export default {
  name: 'appScanLayer',
  data () {
    return {
      tipsLogo: require('../../../assets/img/app_scan_login_img.png'),
      qrcodeIcon: require('../../../assets/img/scanner_icon.png')
    }
  },
  props: {
    qrcodeUrl: {
      type: String,
      default: ''
    }
  },
  components: {
    vueQr
  }
}
</script>

<style scoped>
  .base_qrcode {
    width: 100%;
    height: 150px;
    display: inline-block;
    margin-top: 10%;
    margin-bottom: 12%;
  }
  .qrcode_group {
    display: inline-block;
  }
  .qrcode {
    opacity: 1;
    border: 1.2px solid #cecece;
    border-radius: 6px;
    min-width: 192px;
    min-height: 195px;
  }
  .demo_qrcode {
    text-align: right;
    vertical-align: bottom;
  }
  .demo_qrcode img {
    width: 160px;
    height: 190px;
    margin-left: 20px;
  }
  .base_tips {
    width: 100%;
    margin-top: 10%;
  }
  .tips_title {
    opacity: 1;
    font-size: 15px;
    font-family: PingfangScBold;
    font-weight: 500;
    text-align: center;
    letter-spacing: 1px;
  }
  .tips_body {
    opacity: 1;
    font-size: 12px;
    font-family: PingfangScBold;
    font-weight: 300;
    text-align: center;
    color: #c9cad1;
    letter-spacing: 1px;
    margin-bottom: 80px;
  }
  #light_tips_title {
    color: #FC5E4C;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/popup/appScanLoginLayer.vue